<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-expansion-panels>
					<v-expansion-panel>
						<v-expansion-panel-header>
							{{ $t("Filter") }}
						</v-expansion-panel-header>
						<v-divider></v-divider>
						<v-expansion-panel-content>
							<v-layout row wrap>
								<v-flex xs12 md3>
									<v-text-field
										v-model="filter.name"
										:label="$t('Name')"
										type="text"
										clearable
										hide-details
									></v-text-field>
								</v-flex>
								<v-flex xs12 md3>
									<v-text-field
										v-model="filter.email"
										:label="$t('Email')"
										type="text"
										clearable
										hide-details
									></v-text-field>
								</v-flex>
								<v-flex xs12 md3>
									<v-btn @click="onFilter()" class="mt-3">{{
										$t("Filter")
									}}</v-btn>
								</v-flex>
							</v-layout>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-flex>
			<v-flex xs12>
				<app-datatable
					:title="$t('Roles Datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
					:hasView="true"
				>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button
			@click="$inertia.visit($route('central.roles.create'))"
		></app-create-fab-button>

		<app-delete-dialog
			ref="deleteDialog"
			:endpoint="'central.roles.destroy'"
			:uuid="item.uuid"
		></app-delete-dialog>

		<v-dialog v-model="passwordDialog" width="500" persistent>
			<ValidationObserver ref="obs" v-slot="{ invalid }">
				<v-form>
					<v-card>
						<v-card-title class="text-h5 grey lighten-2">
							{{ $t("Reset Password") }}
						</v-card-title>

						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap row>
									<v-flex xs12>
										<ValidationProvider
											name="new_password"
											rules="required|min:8"
											v-slot="{ errors }"
										>
											<v-text-field
												v-model="password.new_password"
												:label="$t('New Password')"
												prepend-icon="mdi-lock"
												:error-messages="errors"
												:append-icon="
													showPassword
														? 'mdi-eye'
														: 'mdi-eye-off'
												"
												:type="
													showPassword
														? 'text'
														: 'password'
												"
												@click:append="
													showPassword = !showPassword
												"
											></v-text-field>
										</ValidationProvider>
									</v-flex>
									<v-flex xs12>
										<ValidationProvider
											name="new_password_confirmation"
											rules="required|min:8"
											v-slot="{ errors }"
										>
											<v-text-field
												v-model="
													password.new_password_confirmation
												"
												:label="
													$t(
														'New Password Confirmation'
													)
												"
												prepend-icon="mdi-lock"
												:error-messages="errors"
												:append-icon="
													showPassword
														? 'mdi-eye'
														: 'mdi-eye-off'
												"
												:type="
													showPassword
														? 'text'
														: 'password'
												"
												@click:append="
													showPassword = !showPassword
												"
											></v-text-field>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>

						<v-divider></v-divider>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click.native="passwordDialog = false">
								{{ $t("Cancel") }}
							</v-btn>
							<v-btn
								color="primary"
								text
								:loading="password.processing"
								@click.native="changePassword"
								:disabled="invalid"
							>
								{{ $t("Change Password") }}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</ValidationObserver>
		</v-dialog>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
export default {
	remember: {
		data: ["filter"],
	},
	components: {
		Link,
	},
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
			password: {},
			passwordDialog: false,
			showPassword: false,
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.roles.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					width: 80,
					align: "left",
					sortable: false,
				},
				{
					text: this.$t("Name"),
					value: "name",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Permissions Count"),
					value: "permissions_count",
					searchable: false,
					sortable: false,
					align: "center",
				},
				{
					text: this.$t("Users Count"),
					value: "users_count",
					searchable: false,
					sortable: false,
					align: "center",
				},
			];
		},
	},
	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},

		editItem(item) {
			this.$inertia.get(this.$route("central.roles.edit", item.id));
		},

		viewItem(item) {
			this.$inertia.get(this.$route("central.roles.show", item.id));
		},

		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>